module.exports = __webpack_public_path__ + "static/media/CornerUpRight.657a608b.svg";